export const WorldIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5002 19.6087C15.5628 19.6087 19.6668 15.5047 19.6668 10.4421C19.6668 5.37945 15.5628 1.27539 10.5002 1.27539M10.5002 19.6087C5.43755 19.6087 1.3335 15.5047 1.3335 10.4421C1.3335 5.37945 5.43755 1.27539 10.5002 1.27539M10.5002 19.6087C12.3411 19.6087 13.8335 15.5047 13.8335 10.4421C13.8335 5.37945 12.3411 1.27539 10.5002 1.27539M10.5002 19.6087C8.65921 19.6087 7.16683 15.5047 7.16683 10.4421C7.16683 5.37945 8.65921 1.27539 10.5002 1.27539M2.16683 7.10872H18.8335M2.16683 12.9421H18.8335"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
